import React from 'react';
import '../style/components/footer.scss';
const Footer = () => (
  <div className="footer">
    Copyrights © 2018 Liang-Shi-Shu Inc. All rights reserved.
  </div>
);
export default Footer;
